import { apiFetch } from "../api";
import {BASE_URL as u} from "../../commonUrls";

const BASE_URL = `${u}/note`;

export const getAllNotes = async ()=>{
const res = await apiFetch(BASE_URL);
return res.json();
};


export const createNote = async (data)=>{
const res = await apiFetch(BASE_URL,{
method:"POST",
body: JSON.stringify(data)
});
return res.json();
};